import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function RentalComingSoon() {
  const navigate = useNavigate();

  return (
    <div className="page" style={{ textAlign: 'center', padding: 60 }}>
      <div style={{ fontSize: 32, marginBottom: 12 }}>🏘️</div>
      <h1 style={{ fontSize: 22, fontWeight: 600, marginBottom: 8 }}>rental availability — coming soon</h1>
      <p style={{ color: 'var(--text-secondary)', fontSize: 14, maxWidth: 460, margin: '0 auto 24px', lineHeight: 1.6 }}>
        Thanks for telling us what you're looking for. We're still building out Homes4Bid's rental
        marketplace — the ability to predict and bid on rentals before they're available. We'll let
        you know as soon as listings matching your preferences are ready.
      </p>
      <button className="btn btn-primary" onClick={() => navigate('/')}>back to homepage</button>
    </div>
  );
}
